import ReactTooltip from 'react-tooltip';
import { ICoinNewsAI } from '@kattana-io/common';
import Text from '../../atoms/Text';

interface IAIBarProps {
  data: ICoinNewsAI;
}

const AIBar = ({ data }: IAIBarProps) => {
  const total = Object.values(data).reduce((a, b) => a + b, 0);

  if (total === 0) {
    return null;
  }

  return (
    <div className='ai_bar'>
      <Text size={10} className='ai_bar__label'>
        AI
      </Text>
      <div className='ai_bar__rod'>
        {Object.entries(data).map(([key, value]) => {
          const percentage = (value / total) * 100;

          if (!percentage) {
            return null;
          }

          const parsedKey = key.replace('_', ' ');
          return (
            <div
              key={key}
              className={`ai_bar__rod__section ai_bar__rod__${key}`}
              style={{ flexBasis: `${percentage}%` }}
              data-for='ai-bar-tooltip'
              data-tip={`Coin announcements that<br>our model classified as<br>${parsedKey}`}
            />
          );
        })}
      </div>
      <ReactTooltip
        id='ai-bar-tooltip'
        type='light'
        place='bottom'
        effect='solid'
        className='text_tooltip'
        multiline={true}
      />
    </div>
  );
};

export default AIBar;
